// extracted by mini-css-extract-plugin
export default {"activityLogTableContainer":"activity-log-table-container__activity-log-table-container__fY3cx","activityLogTable":"activity-log-table-container__activity-log-table__GV8P3"};